export default "__VITE_ASSET__YWEOlWaV__"